/* CIY home carousels. One behaviour, used by every ciy-home carousel section. */
(function () {
  function init(root) {
    var track = root.querySelector('.ciy-carousel__track');
    var prev = root.querySelector('.ciy-carousel__arrow--prev');
    var next = root.querySelector('.ciy-carousel__arrow--next');
    if (!track) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    function behavior() { return reduce.matches ? 'auto' : 'smooth'; }

    function step() {
      var first = track.firstElementChild;
      if (!first) return 300;
      var gap = parseFloat(getComputedStyle(track).columnGap || '24') || 24;
      return first.getBoundingClientRect().width + gap;
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: behavior() }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: behavior() }); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function boot() { document.querySelectorAll('.ciy-carousel').forEach(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  // Shopify theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', boot);
})();
